/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Text, FontWeight } from '../Text';
import Colors from 'constants/Colors';

const propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.object,
      PropTypes.array
    ]),
    error: PropTypes.string
  }).isRequired,
  validationMinHeight: PropTypes.bool
};

const defaultProps = {
  validationMinHeight: true
};

const ValidationErrorContainer = styled.div`
  width: 100%;
  min-height: ${({ validationMinHeight }) =>
    validationMinHeight ? '20px' : 'auto'};
  margin-bottom: 16px;
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  overflow: hidden;
  text-overflow: ellipsis;
  
  color: ${Colors.DANGER};
`;

const ValidationErrorText = styled(Text)`
  font-size: 12px;
  float: right;
    margin-top: 3px;
`;

// create a component
const ValidationError = ({ meta, validationMinHeight, ...props }) => (
  <ValidationErrorContainer
    isVisible={meta && meta.touched && meta.error}
    validationMinHeight={validationMinHeight}
    {...props}
  >
    {meta && meta.touched && meta.error && (
      <ValidationErrorText weight={FontWeight.Bold}>
        {meta.error}
      </ValidationErrorText>
    )}
    {validationMinHeight}
  </ValidationErrorContainer>
);
ValidationError.propTypes = propTypes;
ValidationError.defaultProps = defaultProps;

export default ValidationError;
